export default __webpack_public_path__ + "static/rollingpin-0fe157a80252ca6d4d61175f99d97667.png";